import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button, Table
} from 'reactstrap';

//import FileDownload from "components/Varios/FileDownload.js";

export default class CardEvaluacionIntegral extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    render() {

        return (
            <div className="col-md-6 col-xs-6" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            <span className="spanCard">AÑO DE EVALUACIÓN: </span> {this.props.objeto.anio}
                            <br />
                            <span className="spanCard">RESOLUCIÓN: </span> {this.props.objeto.resolucion}
                            <br />
                            <span className="spanCard">CALIFICACIÓN: </span> {this.props.objeto.calificacion}
                            <br />
                            <br />
                            <span className="spanCard">FECHA INICIO: </span> {this.parseDate(this.props.objeto.inicio)}
                            <br />
                            <span className="spanCard">FECHA FIN: </span> {this.parseDate(this.props.objeto.fin)}
                            <br />
                            <span>
                                <Table id="evaluacionTable">
                                    <thead>
                                        <tr style={{ textAlign: "right" }}><th align="right">Ámbito</th><th align="right">Horas <br /> Anuales*</th><th align="right">Cal. sobre <br /> 10 puntos</th><th align="right">Ponderación <br />por horas</th><th align="right">Cal. <br /> ponderada</th></tr>
                                    </thead>
                                    <tbody>
                                        {this.props.objeto.docenciahoras ? <tr><td>Docencia</td><td align="right">{this.props.objeto.docenciahoras}</td><td align="right">{this.props.objeto.docenciacalificacion}</td><td align="right">{this.props.objeto.docenciahorasporc}%</td><td align="right">{this.props.objeto.docenciacalificacionpond}</td></tr> : null}
                                        {this.props.objeto.investigacionhoras ? <tr><td>Investigación</td><td align="right">{this.props.objeto.investigacionhoras}</td><td align="right">{this.props.objeto.investigacioncalificacion}</td><td align="right">{this.props.objeto.investigacionhorasporc}%</td><td align="right">{this.props.objeto.investigacioncalificacionpond}</td></tr> : null}
                                        {this.props.objeto.gestionhoras ? <tr><td>Gestión</td><td align="right">{this.props.objeto.gestionhoras}</td><td align="right">{this.props.objeto.gestioncalificacion}</td><td align="right">{this.props.objeto.gestionhorasporc}%</td><td align="right">{this.props.objeto.gestioncalificacionpond}</td></tr> : null}
                                        {this.props.objeto.vinculacionhoras ? <tr><td>Vinculación</td><td align="right">{this.props.objeto.vinculacionhoras}</td><td align="right">{this.props.objeto.vinculacioncalificacion}</td><td align="right">{this.props.objeto.vinculacionhorasporc}%</td><td align="right">{this.props.objeto.vinculacioncalificacionpond}</td></tr> : null}
                                    </tbody>
                                </Table>
                            </span>
                            *Hora Anuales: Información tomada del Sistema de Planificación Académica
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}